export interface WisdomCard {
  id: number;
  keyword: string;
  message: string;
  practice: string;
  category: string;
}

export const problemCategories = [
  { key: 'career', label: '職場壓力', emoji: '\uD83E\uDE91' },
  { key: 'parenting', label: '育兒壓力', emoji: '\uD83E\uDDF8' },
  { key: 'relationship', label: '人際關係壓力', emoji: '\uD83E\uDEC2' },
  { key: 'confusion', label: '生活迷惘', emoji: '\uD83C\uDF2B\uFE0F' },
  { key: 'health', label: '健康壓力', emoji: '\uD83E\uDEC0' },
  { key: 'love', label: '感情壓力', emoji: '\uD83D\uDCA7' },
  { key: 'finance', label: '金錢壓力', emoji: '\uD83D\uDCB0' },
  { key: 'family', label: '家庭壓力', emoji: '\uD83C\uDFE0' },
];

export const wisdomCards: WisdomCard[] = [
  // ============ 職場壓力 career (9 cards) ============
  {
    id: 1,
    keyword: '界線',
    message:
      '你唔需要透過不斷嘅妥協嚟證明自己嘅價值。健康嘅職場界線，係保護你心理健康嘅第一道防線——學識喺適當時候話「我需要時間考慮」，本身就係一種專業。',
    practice:
      '今日，揀一個你平時會即刻答應嘅工作請求，練習用 10 秒停頓先回應。然後問自己：「如果我話需要時間諗一諗，最壞情況會係點？」',
    category: 'career',
  },
  {
    id: 2,
    keyword: '價值',
    message:
      '你嘅價值唔係由你嘅生產力定義。你存在，本身就值得被尊重——即使今日乜都冇做到。',
    practice:
      '今晚臨瞓前，寫低三樣「今日我做咗」嘅事，要包括一項同工作完全無關嘅嘢。',
    category: 'career',
  },
  {
    id: 3,
    keyword: '節奏',
    message:
      '職場就像一個季節循環，樹木不會怪自己冬天生長得慢，你也不需要責怪自己今日狀態不夠完美。容許自己有停頓、有休眠，才有下一次的發芽。',
    practice:
      '今日設定一個「無罪惡感」嘅 15 分鐘小休，唔睇手機，純粹望窗外。容許自己大大方方咁唞一唞。',
    category: 'career',
  },
  {
    id: 4,
    keyword: '微休息',
    message:
      '研究顯示，每工作 90 分鐘後進行 5-10 分鐘嘅微休息（micro-break），可以顯著恢復專注力同降低疲勞感。你唔係機器，你需要嘅係節奏，而唔係冇間斷嘅輸出。',
    practice:
      '今日設定計時器，每 90 分鐘就起身行吓、飲杯水、望吓綠色植物，當係送俾大腦嘅 reset 掣。',
    category: 'career',
  },
  {
    id: 40,
    keyword: '完整',
    message:
      '你唔需要做一個完美嘅員工，你只需要做一個完整嘅自己。將自我價值同工作表現分開——你喺工作上嘅一個失誤，唔會令你作為一個人嘅價值打折扣。細個嘅你，從來唔係因為做得幾出色先值得被愛。',
    practice:
      '今日放工前，寫低一句「今日我做咗一件令自己驕傲嘅事」，要係同工作 KPI 完全無關嘅。',
    category: 'career',
  },
  {
    id: 41,
    keyword: '擁抱',
    message:
      '今日覺得好辛酸？抱一抱體內嗰個好想討好大人嘅小男孩／小女孩，同佢講：「你已經好努力，依家休息吓，冇人會怪你。」',
    practice:
      '將手放心口，閉眼深呼吸，同內在細路講一句安慰說話。',
    category: 'career',
  },
  {
    id: 42,
    keyword: '卸下',
    message:
      '工作只係生活嘅一部分，唔係你嘅全部。卸落工作角色，你依然係一個好珍貴嘅靈魂。',
    practice:
      '放工後，做一件同工作完全無關嘅小事——沖杯茶、聽首歌、行幾步路。',
    category: 'career',
  },
  {
    id: 43,
    keyword: '明天',
    message:
      '件事做唔完，唔代表你唔夠好。今日辛苦喇，試吓將未完成嘅工作，交返俾聽日嘅自己先啦。',
    practice:
      '合埋眼，深呼吸三次，同自己講聲：「今日我已經做得好好。」',
    category: 'career',
  },
  {
    id: 44,
    keyword: '距離',
    message:
      '你唔需要滿足晒所有人嘅期待。學識同工作保持適當距離，先可以保護好內在嘅溫暖。',
    practice:
      '放工後，刪除／靜音所有工作通訊軟件，留一粒鐘俾自己徹底放空。',
    category: 'career',
  },

  // ============ 親子壓力 parenting (9 cards) ============
  {
    id: 5,
    keyword: '足夠',
    message:
      '完美嘅父母並唔存在，小朋友需要嘅只係一個快樂、真實嘅你。今晚，俾自己 15 分鐘嘅絕對空白，你已經做得足夠好喇。',
    practice:
      '今晚將手機放低 15 分鐘，唔好諗小朋友、唔好諗家務，只係坐喺度，純粹呼吸。',
    category: 'parenting',
  },
  {
    id: 6,
    keyword: '內在小孩',
    message:
      '當你照顧緊小朋友嘅同時，有冇諗過你內心都有一個細路等緊你？佢可能攰咗好耐，想俾你攬一攬。',
    practice:
      '今日同小朋友一齊嘅時候，對佢講一句你細個最想聽到嘅說話，同時當係講俾內心嘅自己聽。',
    category: 'parenting',
  },
  {
    id: 7,
    keyword: '溫柔',
    message:
      '你嘅溫柔已經足夠——唔需要每次都係教科書式嘅回應。一個攬、一個眼神，小朋友全部收到晒。',
    practice:
      '今日揀一個小瞬間，放棄「完美做法」，只係同小朋友單純咁笑一下。',
    category: 'parenting',
  },
  {
    id: 8,
    keyword: '同在',
    message:
      '陪伴唔等於犧牲。你喺度，已經係最強嘅安全感來源。唔需要將自己燃燒到盡先叫做愛。',
    practice:
      '今日，喺照顧小朋友之前，先照顧自己——飲一杯完整嘅暖水，唔好俾任何人打斷。',
    category: 'parenting',
  },
  {
    id: 50,
    keyword: '接納',
    message:
      '覺得自己做唔好爸媽？其實細個嘅你，都只係需要一個溫柔嘅擁抱，唔需要完美。',
    practice:
      '攬住自己，閉眼想像返 5 歲嘅你，同佢講：「你唔需要做得幾好，我都愛你。」',
    category: 'parenting',
  },
  {
    id: 51,
    keyword: '勇氣',
    message:
      '今日發咗脾氣？唔緊要，同自己同埋小朋友講聲對唔住。承認軟弱，係最勇敢嘅身教。',
    practice:
      '寫一句「我今日已經做得最好嘅事」喺紙上面，貼喺當眼處。',
    category: 'parenting',
  },
  {
    id: 52,
    keyword: '充電',
    message:
      '你已經做得好好喇。記得，先照顧好體內嗰個攰透嘅小男孩／小女孩，你先有力量去愛眼前嘅孩子。',
    practice:
      '揀一個你細個好鍾意做嘅活動（畫畫、盪鞦韆、食糖），今日俾自己做一次。',
    category: 'parenting',
  },
  {
    id: 53,
    keyword: '原諒',
    message:
      '你唔係超人，會攰、會煩、會想逃離，全部都係正常嘅。原諒自己嘅無力，你嘅愛依然真實。',
    practice:
      '對住鏡講：「我原諒自己今日唔夠耐心，我會同自己一齊慢慢嚟。」',
    category: 'parenting',
  },
  {
    id: 54,
    keyword: '平衡',
    message:
      '養育小朋友同養育自己，其實係同一棵樹嘅兩條根。你根扎得穩，小朋友自然長得好。',
    practice:
      '今晚瞓前，寫低一個你「為自己做」嘅小決定，而唔係為咗任何人。',
    category: 'parenting',
  },

  // ============ 人際關係壓力 relationship (9 cards) ============
  {
    id: 9,
    keyword: '回歸自己',
    message:
      '別人嘅情緒係佢哋嘅課題，唔係你嘅責任。收回試圖討好所有人嘅能量，把溫暖留返俾真正睇到你嘅人。',
    practice:
      '今日對一個「你唔需要討好」嘅人講一句真心話，感受嗰種唔使修飾嘅自由。',
    category: 'relationship',
  },
  {
    id: 10,
    keyword: '篩選',
    message:
      '你唔需要俾所有人鍾意，正如森林入面唔會每一棵樹都向住同一個方向生。你嘅獨特性，本身就會自然篩選到對嘅人。',
    practice:
      '寫低三個你覺得「必須討好」嘅人，然後問自己：佢哋有冇同樣咁珍惜你？',
    category: 'relationship',
  },
  {
    id: 11,
    keyword: '獨處',
    message:
      '社交焦慮嘅背後，可能係你太耐冇好好陪過自己。當你識得同自己相處，你就唔再需要靠別人嘅反應嚟確認自己。',
    practice:
      '今日安排 30 分鐘「絕對獨處」，唔覆訊息、唔 scroll social media，只係同自己一齊。',
    category: 'relationship',
  },
  {
    id: 12,
    keyword: '真誠',
    message:
      '社交唔係表演。你可以攰、可以唔想講嘢、可以只係安安靜靜咁存在。真正嘅連接，係由真實開始。',
    practice:
      '下次聚會，容許自己唔使「搞氣氛」。觀察吓，唔講嘢嘅你係咪都一樣被接納。',
    category: 'relationship',
  },
  {
    id: 55,
    keyword: '討好',
    message:
      '討好所有人係世界上最攰嘅事。試下同內在小孩講：「我哋唔需要全世界都喜歡我哋，我愛你就夠。」',
    practice:
      '拒絕一個今日你唔想去嘅應酬，留時間同自己獨處。',
    category: 'relationship',
  },
  {
    id: 56,
    keyword: '拒絕',
    message:
      '拒絕別人，唔代表你係個壞人，只係代表你開始懂得保護自己嘅能量界線。',
    practice:
      '練習講一句：「多謝你諗起我，但今次我想留返時間俾自己。」',
    category: 'relationship',
  },
  {
    id: 57,
    keyword: '寧靜',
    message:
      '世界好嘈，但你唔需要回應所有聲音。退後一步，留返一個寧靜嘅角落畀自己。',
    practice:
      '喺嘈雜環境入面，閉眼數自己呼吸 10 次，唔理周圍發生咩事。',
    category: 'relationship',
  },
  {
    id: 58,
    keyword: '真實',
    message:
      '人與人之間最舒服嘅關係，係可以坦然做返自己。試下放低迎合別人嘅面具，深呼吸一下。',
    practice:
      '同一個令你覺得最放鬆嘅朋友，發一個簡單嘅問候訊息。',
    category: 'relationship',
  },
  {
    id: 59,
    keyword: '抱抱',
    message:
      '當你覺得被傷害時，請記得先抱抱自己嘅內在小孩。話俾佢聽：「錯嘅唔係你，你係值得被愛嘅。」',
    practice:
      '對鏡入面嘅自己微笑，講一聲：「多謝你今日咁保護我。」',
    category: 'relationship',
  },

  // ============ 生活迷惘 confusion (9 cards) ============
  {
    id: 13,
    keyword: '空白期',
    message:
      '茫然唔係退步，而係靈魂正在重新定位。俾自己而家「唔知道」，慢落嚟，今日只做一件令你感到自在嘅小事。',
    practice:
      '今日唔好諗「人生方向」，只係揀一件令你感到自在嘅小事去做——整一杯好飲嘅嘢、摸吓植物、聽一首歌。',
    category: 'confusion',
  },
  {
    id: 14,
    keyword: '方向',
    message:
      '指南針之所以準確，係因為佢只指向一個方向。你唔需要所有嘢都兼顧，揀一樣，專注落去，其他嘢自然會歸位。',
    practice:
      '今日寫低一個「如果冇任何限制，我會想做嘅嘢」，唔需要諗可行性，純粹寫。',
    category: 'confusion',
  },
  {
    id: 15,
    keyword: '種子',
    message:
      '一粒種子喺泥土入面嘅時候，外面係乜都睇唔到嘅。但佢冇停止過生長。你而家嘅「空白期」，或者就係最深嘅紮根期。',
    practice:
      '去公園搵一棵細樹苗，觀察佢嘅根旁邊嘅泥土，提醒自己：睇唔見嘅嘢，唔等於唔存在。',
    category: 'confusion',
  },
  {
    id: 16,
    keyword: '信任',
    message:
      '你唔需要即刻知道人生嘅終點喺邊。行多一步，光就會照到下一步。你嘅生命有佢自己嘅時間表。',
    practice:
      '今日只專注喺「下一步」——唔係下個月、唔係下年，只係今日之後嘅嗰一步。',
    category: 'confusion',
  },
  {
    id: 60,
    keyword: '冒險',
    message:
      '行錯路唔緊要，人生根本冇冤枉路。每一條路，都係內在小孩陪你探索世界嘅冒險。',
    practice:
      '行一條平時冇行過嘅路返屋企，睇吓沿途會發現啲咩。',
    category: 'confusion',
  },
  {
    id: 61,
    keyword: '軌道',
    message:
      '迷惘係因為你開始聽自己嘅心聲，唔再盲目跟人走。俾時間一啲時間，你一直都喺啱嘅軌道上。',
    practice:
      '寫低一句你而家最想做、但驚被人笑嘅事，收好佢，作為送俾自己嘅禮物。',
    category: 'confusion',
  },
  {
    id: 62,
    keyword: '踏實',
    message:
      '唔知未來點算？咁就睇好眼前呢一秒。吸一口氣，感受腳底踩住大地嘅踏實。',
    practice:
      '赤腳踩喺草地或者地板上，感受自己同大地嘅連結，穩住當下。',
    category: 'confusion',
  },
  {
    id: 63,
    keyword: '慢慢',
    message:
      '內在小孩話俾你聽：「唔好急，我哋一齊慢慢搵。」唔需要即刻有答案，感受當下就足夠。',
    practice:
      '喺公園坐低，望住天空五分鐘，咩都唔諗，淨係感受風同光。',
    category: 'confusion',
  },
  {
    id: 64,
    keyword: '比較',
    message:
      '比較係偷走快樂嘅小偷。每朵花都有自己開花嘅季節，你嘅步調，就係最好嘅步調。',
    practice:
      '今日唔好睇任何社交媒體（IG／FB），專注喺自己食嘅每一口飯、飲嘅每一口水。',
    category: 'confusion',
  },

  // ============ 健康壓力 health (9 cards) ============
  {
    id: 17,
    keyword: '身體對話',
    message:
      '你嘅身體唔係背叛你，佢係用最後嘅力氣同你講：「請你停一停，望吓我。」病痛係身體最誠實嘅語言，聽佢講，唔好怪佢。',
    practice:
      '合埋眼，將雙手放喺你身體最唔舒服嘅位置，用 5 分鐘靜靜感受佢嘅溫度同心跳，同佢講：「我聽到你喇。」',
    category: 'health',
  },
  {
    id: 18,
    keyword: '自癒力',
    message:
      '人體每日有數以億計嘅細胞喺度自我修復。你嘅身體比你諗像中堅強好多。相信佢，佢需要嘅係時間同你嘅耐性，唔係你嘅恐懼。',
    practice:
      '今日做一次「感恩身體掃描」：由頭到腳，逐個部位感謝佢為你做嘅一切。',
    category: 'health',
  },
  {
    id: 19,
    keyword: '接納',
    message:
      '健康唔係一條直線。有高低起伏係正常嘅。唔好因為今日狀態唔好就否定之前所有嘅進步。每一步都算數。',
    practice:
      '畫一條波浪線，喺高點寫低你感覺好嘅日子，喺低點寫低一個你學到嘅嘢。你會發現低點都有佢嘅價值。',
    category: 'health',
  },
  {
    id: 20,
    keyword: '小步',
    message:
      '你唔需要即刻變返「100%」。今日比尋日好 1%，已經係勝利。身體嘅修復係馬拉松，唔係短跑。',
    practice:
      '今日只做一件對身體好嘅小事——飲多杯水、早 15 分鐘瞓、或者伸個三分鐘懶腰。',
    category: 'health',
  },
  {
    id: 65,
    keyword: '求救',
    message:
      '身體嘅痛同緊繃，係體內嗰個細路喺度發出求救訊號。停一停，溫柔咁問吓佢：「你係咪好攰喇？」',
    practice:
      '喺身體最緊嘅位置敷一塊熱毛巾，邊敷邊同自己講：「我收到你嘅訊號喇。」',
    category: 'health',
  },
  {
    id: 66,
    keyword: '陪伴',
    message:
      '對自己嘅身體好啲，唔好再逼佢硬撐。今日嘅任務，就係好好陪伴呢具陪你走過咁多風浪嘅身體。',
    practice:
      '揀一種你身體而家最想嘅食物／飲品，慢慢品嚐，感謝身體嘅每一個反應。',
    category: 'health',
  },
  {
    id: 67,
    keyword: '提醒',
    message:
      '病痛唔係懲罰，係大自然同身體給予你嘅溫柔提醒——係時候放慢腳步，照顧好自己。',
    practice:
      '今日取消一個「應該做」但身體唔想做嘅活動，俾自己完全休息。',
    category: 'health',
  },
  {
    id: 68,
    keyword: '容許',
    message:
      '生病唔代表你軟弱，只代表你係一個有感情、有需要嘅人。容許自己唔好，係康復嘅第一步。',
    practice:
      '寫一封信俾自己嘅身體，感謝佔咁多年嚟從來冇放棄過你。',
    category: 'health',
  },
  {
    id: 69,
    keyword: '根源',
    message:
      '身體嘅症狀，好多時都係心靈嘅語言。唔好淨係醫表面，溫柔咁問心：「你係咪有啲嘢想講俾我聽？」',
    practice:
      '喺紙上面畫一個心，喺入面寫低你最近壓抑咗嘅情緒，然後摺好收埋。',
    category: 'health',
  },

  // ============ 感情壓力 love (9 cards) ============
  {
    id: 21,
    keyword: '自愛',
    message:
      '喺等緊一個人嚟愛你之前，你有冇真係好好咁愛過自己？你俾自己嘅溫柔，先係最唔會離開嘅感情。',
    practice:
      '今晚對住塊鏡，望住自己對眼，認真講一次：「我值得被愛，就係而家呢個模樣。」',
    category: 'love',
  },
  {
    id: 22,
    keyword: '放手',
    message:
      '有啲關係嘅結束，唔係因為你唔夠好，而係你哋嘅生命軌跡去到分岔口。放手，係俾自己有空間迎接真正屬於你嘅擁抱。',
    practice:
      '寫一封信俾嗰個你仲放唔低嘅人，唔需要寄出，寫完之後將佢收埋，同自己講：「我釋放呢段能量。」',
    category: 'love',
  },
  {
    id: 23,
    keyword: '完整',
    message:
      '你唔需要另一個人先可以完整。你本身就係一棵完整嘅樹——開花、結果、落葉，全部都係你自己嘅節奏。伴侶只係一齊欣賞風景嘅旅人。',
    practice:
      '今日做一件「同任何人都無關」、純粹令你自己開心嘅事，感受嗰種唔使依賴任何人嘅自由。',
    category: 'love',
  },
  {
    id: 24,
    keyword: '傷口',
    message:
      '每一次心痛都係內在小孩喺度敲門。佢想話俾你聽，有啲舊傷口仲未癒合。停低，攬下佢，俾佢知道你已經大個咗，可以保護返佢。',
    practice:
      '合埋眼，想像你細個嗰陣最孤單嘅一個畫面。而家嘅你行過去，攬住當時嘅自己，靜靜咁陪佢坐五分鐘。',
    category: 'love',
  },
  {
    id: 70,
    keyword: '靠山',
    message:
      '你唔需要委屈自己去換取愛。真正嘅安全感，來自於你願唔願意成為自己最強大嘅靠山。',
    practice:
      '寫低三樣你可以為自己做、而唔需要等人嚟做嘅事，揀一樣今日完成。',
    category: 'love',
  },
  {
    id: 71,
    keyword: '保護',
    message:
      '害怕被拋棄？其實你已經長大，永遠有能力擁抱自己。體內嗰個受過傷嘅細路，依家有你保護。',
    practice:
      '喺紙上面畫一個盾牌，喺入面寫低你會點樣保護自己嘅內在小孩。',
    category: 'love',
  },
  {
    id: 72,
    keyword: '接納',
    message:
      '愛人之前，先接納自己嘅不完美。當你學會無條件愛自己，自然會吸引到懂得珍惜你嘅人。',
    practice:
      '列出三個你覺得自己嘅「缺點」，然後逐個改寫為「特點」——佢哋令你成為獨一無二嘅你。',
    category: 'love',
  },
  {
    id: 73,
    keyword: '等待',
    message:
      '你唔係剩返，你係喺度為啱嘅人保留最好嘅自己。單身唔係懲罰，係靈魂準備緊下一次更真實嘅相遇。',
    practice:
      '為自己做一頓精心嘅晚餐，當係同最理想嘅自己約會。',
    category: 'love',
  },
  {
    id: 74,
    keyword: '釋懷',
    message:
      '有啲人離開，係因為佢哋只係你生命入面嘅過客。唔好勉強留低一啲本來就唔屬於你嘅劇本。',
    practice:
      '將一樣象徵舊感情嘅小物件，放喺一個盒子入面收好，代表你已經將佢交返俾過去。',
    category: 'love',
  },

  // ============ 金錢壓力 finance (7 cards) ============
  {
    id: 75,
    keyword: '選擇權',
    message:
      '儲錢唔只係為咗數字，係為咗比自己選擇權同說「不」嘅底氣。當你知道自己有後路，你嘅每一個決定都可以係出自真心，而唔係恐懼。',
    practice:
      '今日寫低一個「如果有足夠金錢，我會做嘅選擇」，然後諗吓有冇一個縮小版可以今日開始。',
    category: 'finance',
  },
  {
    id: 76,
    keyword: '探索',
    message:
      '問下自己：「我驚冇錢，其實係驚失去自由，定係驚自己唔夠好？」金錢焦慮嘅底層，往往藏住一個更深嘅自我價值問題——當你願意直面佢，焦慮就開始鬆綁。',
    practice:
      '寫低你對金錢最驚嘅一件事，然後反問自己：「呢個恐懼，其實同錢有幾大關係？」',
    category: 'finance',
  },
  {
    id: 77,
    keyword: '夠用',
    message:
      '不與他人比較。每週盤點一次花費，劃清「想要」同「焦慮」嘅界線。好多時候我哋花錢並唔係因為需要，而係想用消費去填補內心嘅某個窿——認出呢個模式，你就開始自由。',
    practice:
      '今個星期，每次想買嘢之前問自己三個字：「我需要？」然後等三分鐘先決定。',
    category: 'finance',
  },
  {
    id: 78,
    keyword: '掌控',
    message:
      '試記下每次花錢時嘅情緒，留一筆預算比自己睇展、飲茶、養足靈魂。金錢唔應該淨係用嚟生存，佢都可以用嚟滋養你內在嘅生命力——為自己嘅靈魂留一筆「不可商量」嘅快樂基金。',
    practice:
      '設定一個「靈魂基金」，每月固定一筆錢淨係用嚟做令自己真正快樂嘅事，唔需要同任何人交代。',
    category: 'finance',
  },
  {
    id: 79,
    keyword: '底氣',
    message:
      '真正嘅安全感唔係來自帳戶數字，係來自相信自己「就算面對不確定，都有能力照顧好自己」嘅底氣。金錢只係工具，而你嘅韌性、適應力同創造力，先係永遠跟住你嘅真正資產。',
    practice:
      '列出五樣你擁有、但同金錢完全無關嘅「內在資源」（例如：解決問題嘅能力、彈性、創意、善良、堅持），放喺當眼處提醒自己。',
    category: 'finance',
  },
  {
    id: 80,
    keyword: '接納',
    message:
      '金錢焦慮唔係你嘅錯，佢只係提醒緊你：有啲內在需求等待被理解。可能係細個時候見過父母為錢吵架、可能係曾經歷過匱乏——呢啲都唔係你需要感到羞恥嘅事，佢哋只係等緊被你看見同溫柔承接。',
    practice:
      '合埋眼，將手放喺心口，同自己講：「我嘅焦慮係真實嘅，我唔需要否定佢。我願意溫柔咁了解佢想講咩。」',
    category: 'finance',
  },
  {
    id: 81,
    keyword: '價值',
    message:
      '你不需一直用「夠唔夠錢」嚟證明自己嘅價值，你本來就值得被好好照顧。金錢係流動嘅能量，而你嘅存在價值係恆定嘅——兩者從來都唔應該被掛鉤。',
    practice:
      '對住塊鏡，望住自己嘅眼，講三次：「我嘅價值，同金錢無關。我本身就值得被善待。」然後做一件唔使錢但令自己感到被照顧嘅事。',
    category: 'finance',
  },

  // ============ 家庭壓力 family (7 cards) ============
  {
    id: 82,
    keyword: '界線',
    message:
      '家庭嘅愛有時會以「控制」或者「期望」嘅形式出現。設立界線唔代表你唔愛佢哋，而係代表你開始學識愛自己。真正嘅孝順，包括保護自己嘅心靈空間。',
    practice:
      '今日練習講一句：「我明白你嘅關心，但我需要按照自己嘅節奏嚟。」唔需要解釋太多，簡簡單單就已經係一個界線。',
    category: 'family',
  },
  {
    id: 83,
    keyword: '原諒',
    message:
      '家人傷害過你，唔代表你要忘記或者假裝冇事。但原諒係為咗釋放你自己——你唔需要孭住上一代嘅傷口過你嘅人生。你值得擁有屬於自己嘅、輕盈嘅未來。',
    practice:
      '寫一封唔寄出嘅信俾一個你仲未原諒嘅家人，寫晒你想講嘅嘢。寫完之後，將封信摺好，同自己講：「我釋放呢段能量，我唔需要再孭住佢。」',
    category: 'family',
  },
  {
    id: 84,
    keyword: '選擇',
    message:
      '你可能覺得被家庭嘅期望壓住——要讀咩科、要做咩工、要幾時結婚。但請記住：呢個係你嘅人生，你有權選擇自己嘅路。選擇唔聽話，唔代表你唔孝順，只係代表你尊重自己嘅生命。',
    practice:
      '寫低一個「如果冇家庭壓力，我會做嘅選擇」，然後問自己：有咩小步驟可以今日開始向呢個方向行一步？',
    category: 'family',
  },
  {
    id: 85,
    keyword: '根源',
    message:
      '家庭係你嘅根，但根嘅作用係支撐你向上生長，而唔係將你綁死喺原地。你可以在感恩根源嘅同時，向你選擇嘅天空伸展——呢兩件事並唔矛盾。',
    practice:
      '畫一棵樹，喺根部寫低你感恩家庭嘅三樣嘢，喺樹冠寫低你想成為嘅三樣嘢。提醒自己：根同樹冠，可以同時存在。',
    category: 'family',
  },
  {
    id: 86,
    keyword: '獨立',
    message:
      '情感上嘅獨立，唔等於同家人割裂。佢係一種能力——你可以聽見佢哋嘅聲音，但最終決定權喺你手。你嘅情緒唔需要被佢哋嘅反應綑綁，你有權擁有自己嘅平靜。',
    practice:
      '今日當家人嘅說話令你情緒起伏嘅時候，停三秒，深吸一口氣，喺心入面同自己講：「呢個係佢嘅感受，唔係我嘅責任。」',
    category: 'family',
  },
  {
    id: 87,
    keyword: '傳承',
    message:
      '有啲家庭模式一代傳一代——唔係基因，係習慣。但你唔需要重複上一代嘅劇本。你可以係家族入面第一個打破循環嘅人——呢個需要勇氣，但你絕對做得到。',
    practice:
      '諗一個你想打破嘅家庭模式（例如：唔識表達愛、用批評代替關心），然後諗一個具體嘅新做法，今日開始練習。',
    category: 'family',
  },
  {
    id: 88,
    keyword: '和解',
    message:
      '和解唔一定要面對面講清楚。有時和解係你內心嘅一個決定——你決定唔再讓過去嘅傷口定義你而家嘅幸福。你可以在唔改变對方嘅情況下，為自己創造內心嘅和平。',
    practice:
      '合埋眼，想像你同一個家人身處同一個寧靜嘅森林，冇說話，只係一齊望住同一棵樹。感受呢份沉默嘅共存，然後慢慢睜開眼。',
    category: 'family',
  },
];